:host {
  display: inline-flex;
  width: auto;
  align-items: center;
  padding: 0 calc(var(--spacer) * 2) 0 0;
  white-space: nowrap;
  color: var(--chart-300-icon-buttons);
  font-size: var(--body-size-xsmall);
}

.loader {
  display: inline-flex;
  align-items: center;
  width: 120px;
}

